<div class="row mt-3 mb-3">
  <div *ngIf="!somenteVisualizar && rcms && !rcms.contrato?.id" class="col-sm-6 d-flex align-items-center">
    <button (click)="adicionar()" [disabled]="disabled()" class="btn btn-sm btn-outline-primary">
      <i class="fa fa-plus"></i>
      Adicionar Fornecedor
    </button>
  </div>
  <div *ngIf="!somenteVisualizar && rcms && !rcms.contrato?.id"
    class="col-sm-6 d-flex flex-column justify-content-center align-items-end">
    <span class="text-success">
      <span class="badge badge-success mr-2">Ctrl + I</span> Adicionar novo fornecedor
    </span>
    <span class="text-danger">
      <span class="badge badge-danger mr-2">Ctrl + O</span> Cancelar cadastro/alteração de fornecedor
    </span>
  </div>
  <div *ngIf="!somenteVisualizar && rcms && rcms.contrato?.id" class="col-sm-6">
    <span class="text-primary">
      <i class="fa fa-info"></i> Bloqueado edição para requisições com contrato
    </span>
  </div>
</div>
<table class="table table-eddy" style="font-size: 12px" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th scope="col" style="width: 20%;">CPF/CNPJ</th>
      <th scope="col" style="width: 70%;">Razão Social</th>
      <th scope="col" style="width: 120px;" class="text-center"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="item.editavel" [colSpan]="item.editavel ? '2' : '1'">
        <p-autoComplete #favorecido id="favorecido" [(ngModel)]="item.favorecido" [forceSelection]="true"
          [autoHighlight]="true" [ngModelOptions]="{standalone: true}" [field]="favorecidoAutoComplete.conversor"
          [suggestions]="favorecidoAutoComplete.lista" (completeMethod)="favorecidoAutoComplete.filtrar($event)"
          inputStyleClass="form-control" [style]="{ width: 'calc(100% - 46px)', float: 'left' }" minLength="2"
          (onKeyUp)="salvarEnterEvent($event, item)">
          <ng-template let-favorecido pTemplate="item">
            {{favorecido.cpf_cnpj | CPF}} {{favorecido.nome}}
          </ng-template>
        </p-autoComplete>
        <button class="btn btn-outline-secondary float-right" type="button" data-toggle="modal"
          style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;"
          (click)="editarFavorecido(item)">
          <i class="fa fa-user-plus"></i>
        </button>
      </td>
      <td *ngIf="!item.editavel">
        {{item.favorecido.cpf_cnpj}}
      </td>
      <td *ngIf="!item.editavel">
        {{item.favorecido.nome}}
      </td>
      <td class="text-right" style="min-width: 120px;">
        <button *ngIf="item.editavel && !somenteVisualizar && rcms && !rcms.contrato?.id" (click)="salvar(item)"
          class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel && !somenteVisualizar && rcms && !rcms.contrato?.id" (click)="cancelar(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && !somenteVisualizar && rcms && !rcms.contrato?.id" [disabled]="disabled()"
          (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && !somenteVisualizar && rcms && !rcms.contrato?.id" [disabled]="disabled()"
          (click)="remover(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>
<lib-favorecido-cadastro-dlg [login]="login" [entidade]="favorecidoEdit.favorecido"
  (callback)="callbackFavorecido($event)">
</lib-favorecido-cadastro-dlg>